<template>
	<div class="row">
		<div class="col-sm-11 rounded-10 py-4 mx-auto">
			<BreadCrumb name="User" />
			<UserTable v-if="masterStore.state.activeComponent === 'table'" />
			<UserCreate v-if="masterStore.state.activeComponent === 'create'" />
			<UserEdit v-if="masterStore.state.activeComponent === 'edit'" />
			<UserShow v-if="masterStore.state.activeComponent === 'view'" />
		</div>
	</div>
</template>
<script>
	import { inject, watch, onBeforeUnmount } from "vue";
	import API from "@/config/api";
	import toast from "@/config/toast";

	import BreadCrumb from "@/partials/MasterBreadCrumb";
	import UserTable from "@/components/UserTable";
	import UserCreate from "@/components/UserCreate";
	import UserEdit from "@/components/UserEdit";
	import UserShow from "@/components/UserShow";

	export default {
		name: "User",
		components: {
			BreadCrumb,
			UserTable,
			UserCreate,
			UserEdit,
			UserShow,
		},

		setup: () => {
			const masterStore = inject("masterStore", masterStore);

			const deleteData = async (id) => {
				try {
					await API.privateRequest.delete(
						`/users/${masterStore.state.deleteId}`,
					);
					toast.success(
						{ message: "User Removed!", position: "topRight" },
						true,
					);
					const newStoreData = masterStore.state.data.filter(
						(item) => item._id !== id,
					);
					masterStore.methods.changeData(newStoreData);
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
				}
			};
			watch(
				() => masterStore.state.deleteId,
				(newDeleteId, previousDeleteId) => {
					if (!newDeleteId) return;
					deleteData(newDeleteId);
					masterStore.methods.setId("delete", previousDeleteId);
				},
			);
			onBeforeUnmount(masterStore.methods.destroy());

			return {
				deleteData,
				masterStore,
			};
		},
	};
</script>
